import { atom } from "jotai";

import { selectedRoundAtom } from "../../stores";

export const getTransportationTypeIdOnRoundAtom = atom((get) => {
  const selectedRound = get(selectedRoundAtom);
  return selectedRound?.transportationTypeId || "";
});
